import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import DatetimePicker from 'ui-library/inputs/DatetimePicker';

import {DateInputProps, DatetimeInputProps} from './InputConstants';

type BaseDatetimeInputProps =
  | (DatetimeInputProps & {showTimeInput: true})
  | (DateInputProps & {showTimeInput: false});

export function BaseDatetimeInput(props: BaseDatetimeInputProps): JSX.Element {
  return (
    <DatetimePicker
      {...props}
      datetimeInputClassName={classNames(
        Boolean(props.datePickerPopperContainerSelector) && css(styles.pickerDatetimeInputWithoutBorder)
      )}
      popperModifiers={{
        // TODO(BNCH-29431): parameterize these modifiers
        // when rendering in a notebook's structured table, the popper needs to be manually offset to be aligned with
        // the table cell's boundaries
        offset: {
          enabled: Boolean(props.datePickerPopperContainerSelector),
          offset: '-6px, 6px',
        },
        preventOverflow: {
          enabled: true,
          escapeWithReference: true,
          boundariesElement: 'viewport',
        },
      }}
      calendarClassName={props.wrapperClassName}
      showPopperArrow={false}
      disabled={props.isDisabled}
    />
  );
}

export function DateInput(props: DateInputProps): JSX.Element {
  return <BaseDatetimeInput {...props} showTimeInput={false} />;
}

DateInput.defaultProps = {
  autoFocus: false,
  hasButton: false,
  validDatetimeInputFormats: ['YYYY-MM-DD'],
  datetimePresentationalFormat: 'YYYY-MM-DD',
};

export default function DatetimeInput(props: DatetimeInputProps): JSX.Element {
  return <BaseDatetimeInput {...props} showTimeInput={true} />;
}

DatetimeInput.defaultProps = {
  autoFocus: false,
  hasButton: false,
};

const styles = StyleSheet.create({
  pickerDatetimeInputWithoutBorder: {
    border: 'none',
  },
});
